var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isListPage)?_c('ArticleList',{attrs:{"categoryId":_vm.pid,"pageTitle":_vm.pname,"layout":"list","detailPath":"/join/joindetail","sidebar":_vm.subCates,"showAll":false}}):_vm._e(),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }